import { isPossiblePhoneNumber } from "libphonenumber-js";
import { string } from "yup";

export function yupPhoneNumber(message?: string) {
  return string().test(
    "Invalid phone number",
    message ?? "Invalid phone number",
    function (input) {
      // Handle empty numbers using other yup functions
      if (!input) {
        return true;
      }
      
      // isPossiblePhoneNumber matches the validation we use on the backend, as opposed to isValidPhoneNumber
      return isPossiblePhoneNumber(input, "US");
    }
  );
}
